import { Component, OnInit } from '@angular/core';
import { UserService } from '../../services/usre.service';
import { isCallChain } from 'typescript';


@Component({
  selector: 'app-mfa',
  templateUrl: './mfa.component.html',
  styleUrls: ['./mfa.component.scss']
})

export class MfaComponent implements OnInit {

  email: string = '';
  isSuccess: boolean = false;

  constructor(private user: UserService) { }

  ngOnInit() {
    this.user.getUserOtpEmail((suc) => { this.email = suc; }, (err) => { });
  }

  save() {
    this.user.setUserOtpEmail(this.email, (suc) => { this.isSuccess = true; }, (err) => { });
  }

}
